import {
  $getRoot, $isElementNode, $isLineBreakNode, $isTextNode,
} from "lexical"
import { $isMergeTagNode } from "./MergeTagNode"

// eslint-disable-next-line import/prefer-default-export
export const serializeMergeTagEditorToPlainText = (): string => {
  const root = $getRoot()
  const paragraphs = root.getChildren()
  const parts: string[] = []

  paragraphs.forEach((paragraph, pIndex) => {
    if (pIndex > 0) parts.push("\n")

    if (!$isElementNode(paragraph)) {
      parts.push(paragraph.getTextContent())

      return
    }

    paragraph.getChildren().forEach((child) => {
      if ($isTextNode(child)) {
        parts.push(child.getTextContent())
      } else if ($isMergeTagNode(child)) {
        parts.push(`{{${child.getTagId()}}}`)
      } else if ($isLineBreakNode(child)) {
        parts.push("\n")
      }
    })
  })

  return parts.join("")
}
